import React, { useEffect, useState, useContext } from 'react';
import DOMPurify from 'dompurify';
import { TranslateContext } from '../../../widgets/MyDataHelps/TranslateContext';

export interface LocalizedTextProps {
    textKey: string
    values?: { [key: string]: any }
}

function LocalizedText(props: LocalizedTextProps) {
    const translate = useContext(TranslateContext);
    const [text, setText] = useState("");

    const translateText = async () => (
        translate(props.textKey, props.values)
            .then(function (value: string) {
                // set text for the current language
                setText(value);
            })
            .catch(function (value: string) {
                // set text to the textKey value
                setText(value);
            })
    )

    useEffect(() => {
        translateText();
    }, [translate.use?.(), props.values, props.textKey]);

    if (text.indexOf('<') >= 0) {
        const sanitizedHtml = DOMPurify.sanitize(text);
        return (<div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />);
    }
    else {
        return (<>{text}</>);
    }
}

export default LocalizedText;